// Components==============
import { faText, faVolume, faStop } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import React, { useEffect } from 'react';
import './RoundButtons.module.scss';

import useSound from 'use-sound';
import { usePrevious } from 'utilities/usePrevious';
// =========================

type SpeakerProps = {
    audio?: string;
    setShouldAnimate: React.Dispatch<React.SetStateAction<boolean>>;
    animations?: boolean;
};

export function Speaker({ audio, setShouldAnimate, animations }: SpeakerProps) {
    const url = audio?.includes('/audio') ? audio : `/storage/${audio}`;

    const [play, { stop, isPlaying, sound }] = useSound(url);

    useEffect(() => () => stop(), [sound?._src, url]);

    // this effect autoPlays the audio when rendered
    useEffect(() => {
        if (sound && sound._src) {
            play();
        }
    }, [sound?._src]);

    const previousValue = usePrevious(isPlaying);

    useEffect(() => {
        if (!animations) return;
        if (!isPlaying && previousValue) setShouldAnimate(true);
    }, [animations, isPlaying]);

    useEffect(() => {
        setShouldAnimate(false);
    }, [sound?._src]);

    return (
        <motion.div
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.9 }}
            styleName={`button ${audio ? 'audio' : ''}`}
            onClick={() => {
                if (isPlaying) {
                    stop();
                } else {
                    play();
                }
            }}
        >
            <FontAwesomeIcon icon={isPlaying ? faStop : faVolume} />
        </motion.div>
    );
}

type ExpandProps = {
    textExpended: boolean;
    setTextExpended: React.Dispatch<React.SetStateAction<boolean>>;
    text?: string | React.ReactNode;
};

export function Expand({ textExpended, setTextExpended, text }: ExpandProps) {
    return (
        <motion.div
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.9 }}
            styleName={`button ${textExpended && text ? 'collapsed' : ''}`}
            onClick={() => {
                if (text) setTextExpended((prev) => !prev);
            }}
        >
            <FontAwesomeIcon icon={faText} />
        </motion.div>
    );
}
